import React from "react";

export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        height: "100vh", gap: 16, fontFamily: "Inter, system-ui, sans-serif",
        background: "#0f1117", color: "#e2e8f0", padding: "0 24px", textAlign: "center",
      }}>
        <div style={{ width: 64, height: 64, borderRadius: 18, background: "rgba(244,63,94,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#f43f5e" strokeWidth="1.8">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "#f1f5f9", marginBottom: 8 }}>Something went wrong</div>
          <div style={{ fontSize: 13, color: "#94a3b8", maxWidth: 400, lineHeight: 1.7 }}>
            An unexpected error occurred. Reload the page to try again — your data is safe.
          </div>
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: 4, padding: "10px 28px", borderRadius: 10, border: "none", cursor: "pointer",
            background: "linear-gradient(135deg,#6366f1,#8b5cf6)", color: "#fff",
            fontSize: 13, fontWeight: 700, fontFamily: "inherit",
          }}
        >
          Reload Page
        </button>
        {process.env.NODE_ENV !== "production" && this.state.error && (
          <pre style={{
            marginTop: 8, padding: "12px 16px", background: "#1e1e2e", borderRadius: 10,
            fontSize: 11, color: "#f87171", textAlign: "left", maxWidth: 600,
            overflow: "auto", maxHeight: 200, width: "100%",
          }}>
            {this.state.error.toString()}
          </pre>
        )}
      </div>
    );
  }
}
